<template>
    <div  class="text-monospace" style="font-size: 13px;">
        <b-card>
            <b-input v-model="query" style="width: 80%; display: inline-block; vertical-align: top;" size="lg" placeholder="enter invoice id OR customer name OR email OR phone"></b-input>
            <b-button size="lg" @click="fetch_invoices" style="display: inline-block; vertical-align: top;">SEARCH</b-button>
        </b-card>


        <div style="margin-top: 10px;">
            <div v-if="search_in_progress">
                <div>
                    <loading 
                    :active="true" 
                    :can-cancel="false" 
                    :is-full-page="false">
                    </loading>
                </div>
            </div>
            <div v-if="search_in_progress == false">
                <b-card v-if="search_results.length > 0">
                    <table style="width: 100%">
                        <thead>
                            <tr style="background-color: black; color: white;">
                                <td class="ipt_tdhr">
                                    SALE DATE
                                </td>
                                <td class="ipt_tdhr">
                                    INVOICE #
                                </td>
                                <td class="ipt_tdhr">
                                    SOLD FROM
                                </td>
                                <td class="ipt_tdhr">
                                    INVOICE #
                                </td>
                                <td class="ipt_tdhr">
                                    CUSTOMER NAME
                                </td>
                                <td class="ipt_tdhr">
                                    CUSTOMER EMAIL
                                </td>
                                <td class="ipt_tdhr">
                                    CUSTOMER PHONES
                                </td>
                                <td class="ipt_tdhr">
                                    CITY
                                </td>
                                <td class="ipt_tdhr">
                                    # ITEMS
                                </td>
                                <td class="ipt_tdhr">
                                    ACTION
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item, idx in search_results" v-bind:key="idx">
                                <td class="ipt_tdr">
                                    {{ item.ts }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ packet.locsubsdict[item.locsub] }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ item.invoice_id }}
                                </td>

                                <td class="ipt_tdr">
                                    {{ ((item.customer || {}).fullname || '').toUpperCase() }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ ((item.customer || {}).email || '').toUpperCase() }}
                                </td>

                                <td class="ipt_tdr">
                                    {{ ((item.customer || {}).phone || '').toUpperCase() }}
                                    / 
                                    {{ ((item.customer || {}).phone_2 || '').toUpperCase() }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ ((item.customer || {}).city || '').toUpperCase() }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ item.nitems }}
                                </td>

                                <td class="ipt_tdr">
                                    <div v-if="item.is_allowed">
                                        <b-button variant="success" :disabled="true">ALLOWED</b-button>
                                    </div>
                                    <div v-else>
                                        <div v-if="item.modify_requested">
                                            <b-button size="sm" variant="primary" :disabled="true">ALREADY REQUESTED</b-button>
                                        </div>
                                        <div v-else>
                                            <b-button size="sm" variant="primary" @click="request_refund(item)">REQUEST</b-button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
                <b-card v-else>
                    <b-alert show>NO INVOICES FOUND BASED ON YOUR QUERY</b-alert>
                </b-card>
            </div>
        </div>


        <div style="margin-top: 10px;">
            <div v-if="items_being_loaded">
                <loading 
                :active="true" 
                :can-cancel="false" 
                :is-full-page="false">
                </loading>
            </div>
            <div v-else-if="items_being_loaded == false">
                <b-card title="REFUND REQUESTS">
                    <div v-if="items.length == 0">
                        <b-alert show variant="primary">NO REFUNDS REQUESTED YET.</b-alert>
                    </div>
                    <div v-else>
                        <table style="width: 100%">
                            <thead>
                                <tr style="background-color: black; color: white;">
                                    <td class="ipt_tdhr">
                                        SALE DATE
                                    </td>
                                    <td class="ipt_tdhr">
                                        INVOICE #
                                    </td>
                                    <td class="ipt_tdhr">
                                        SOLD FROM
                                    </td>
                                    <td class="ipt_tdhr">
                                        CUSTOMER NAME
                                    </td>
                                    <td class="ipt_tdhr">
                                        CUSTOMER EMAIL
                                    </td>
                                    <td class="ipt_tdhr">
                                        CUSTOMER PHONES
                                    </td>
                                    <td class="ipt_tdhr">
                                        CITY
                                    </td>
                                    <td class="ipt_tdhr">
                                        # ITEMS
                                    </td>
                                    <td class="ipt_tdhr">
                                        ACTION
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="titem, tidx in items" v-bind:key="tidx">
                                    <td class="ipt_tdr">
                                        {{ titem.ts }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ titem.invoice_id }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ packet.locsubsdict[titem.locsub] }}
                                    </td>

                                    <td class="ipt_tdr">
                                        {{ ((titem.customer || {}).fullname || '').toUpperCase() }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ ((titem.customer || {}).email || '').toUpperCase() }}
                                    </td>

                                    <td class="ipt_tdr">
                                        {{ ((titem.customer || {}).phone || '').toUpperCase() }}
                                        / 
                                        {{ ((titem.customer || {}).phone_2 || '').toUpperCase() }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ ((titem.customer || {}).city || '').toUpperCase() }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ titem.nitems }}
                                    </td>
                                    <td class="ipt_tdr">
                                        <b-button size="sm" variant="primary" :disabled="true">ALREADY REQUESTED</b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import Requestor from '@/utilities/Requestor'
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "RefundRequests",
        
        components: {DatePicker, Loading},
        data: function(){
            return {
                items_being_loaded: null,
                items: [],
                search_results: [],
                query: null,
                search_in_progress: null,
            }
        },
        methods: {
            request_refund: function(item){
                let path = "/api/sales/update_invoice_modify/"
                let data = {invoice_id: item.invoice_id, modify_requested: true};
                let that = this;

                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "REQUESTED REFUND ALLOW FOR INVOICE.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.search_results = [];
                    }
                    that.search_in_progress = false;
                    that.fetch_init()
                }
                let f = function(error) {
              
                    that.$bvToast.toast(
                        "Error requesting redund allowance. please try later.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.search_in_progress = false;
                    that.fetch_init()
                }
                that.search_in_progress = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            fetch_invoices: function(){
                let path = "/api/sales/search_invoices_v2/"
                let data = {query: this.query};
                let that = this;

                let s = function(response) {
                    if (response.data.result.length > 0) {
                        that.search_results = response.data.result;
                    }
                    else {

                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.search_in_progress = false;
                }
                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error looking up invoices.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.search_in_progress = false;
                }
                that.search_in_progress = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            fetch_init: function(){
                let path = "/api/sales/get_all_invoices_with_refunds_requested/"
                let data = {};
                let that = this;

                let s = function(response) {
                    if (response.data.result.length > 0) {
                        that.items = response.data.result;
                    }
                    else {
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error, 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading refund requests.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded=false;
                }
                this.items_being_loaded = true;
                Requestor.getAsyncP(path, data, this, s, f);
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            let that = this;
            this.fetch_init()
        }

    }
</script>

<style scoped>
    img.preview {
        width: 100px;
        background-color: white;
        border: 1px solid #DDD;
        padding: 5px;
        margin: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/CustomerService/RefundRequests.vue